import React from 'react';
import styled from 'styled-components';

// ############################ Styles ###########################
// tslint:disable:variable-name

const SLegalText = styled.section<{ inline: boolean }>(
  ({ theme, inline }) => `
  ${inline ? 'display: inline;' : ''}
  font-weight: ${theme.font.weight.normal};
  color: ${theme.colors.primary};
  text-align: justify;
  font-size: ${theme.font.size.small};
  @media only screen and ${theme.device.laptopS} {
    font-size: ${theme.font.size.smallMedium2};
  }
`
);

// tslint:enable:variable-name
// ############################ End Styles ###########################

interface ILegalTextProps {
  dataAt: string;
  className?: string;
  inline?: boolean;
}

// tslint:disable-next-line:variable-name
const LegalText: React.FC<ILegalTextProps> = (props) => (
  <SLegalText inline={Boolean(props.inline)} className={props.className} data-at={props.dataAt}>
    {props.children}
  </SLegalText>
);

export default LegalText;
